import { createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "\n      d-flex\n      flex-column flex-column-fluid\n      bgi-position-y-bottom\n      position-x-center\n      bgi-no-repeat bgi-size-contain bgi-attachment-fixed\n    " }
const _hoisted_2 = { class: "d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20" }
const _hoisted_3 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "mb-12"
}, [
  /*#__PURE__*/_createVNode("img", {
    alt: "Logo",
    src: "media/logos/Pryal.png",
    class: "h-100px"
  })
], -1)
const _hoisted_4 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "text-dark mb-3" }, "Pesquisa de laudo")
], -1)
const _hoisted_6 = { class: "fv-row mb-10" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Renavam", -1)
const _hoisted_8 = { class: "fv-plugins-message-container" }
const _hoisted_9 = { class: "fv-help-block" }
const _hoisted_10 = { class: "fv-row mb-10" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "d-flex flex-stack mb-2" }, [
  /*#__PURE__*/_createVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, "Placa")
], -1)
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "fv-row mb-10" }
const _hoisted_15 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "form-check-label fw-bold text-gray-700 fs-6" }, [
  /*#__PURE__*/_createTextVNode(" Eu li e aceitos os & "),
  /*#__PURE__*/_createVNode("a", {
    href: "#pryal_termos",
    "data-bs-toggle": "modal",
    class: "ms-1 link-primary"
  }, "Termos e condições da Pryal"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " Procurar ", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Procurando... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_20 = {
  class: "modal fade",
  ref: "modal",
  tabindex: "-1",
  id: "pryal_termos"
}
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"\n        modal-dialog\n        modal-dialog-centered\n        modal-dialog-scrollable\n        modal-fullscreen-sm-down\n      \"><div class=\"modal-content\"><div class=\"modal-header\"><h5 class=\"modal-title d-flex flex-column align-items-start\"><span> Termos e condições da PRYAL </span></h5><div class=\"btn btn-icon btn-sm btn-active-light-primary ms-2\" data-bs-dismiss=\"modal\" aria-label=\"Close\"><span class=\"svg-icon svg-icon-2x\"></span></div></div><div class=\"modal-body\"><p>A PRYAL, em seus processos de vistoria, utiliza consultas em bases de dados fornecidas por empresas terceiras. A PRYAL não possui responsabilidade sobre o fornecimento de tais dados, vez que se trata de mera apresentação de informações sobre veículos automotores registrados em bases públicas e privadas, estas detentoras do conteúdo. A vistoria e a apresentação das informações são ferramentas de auxílio para proprietários, compradores e vendedores, úteis na decisão de realização ou não de eventual negócio jurídico, no entanto não se confundem com uma recomendação. A PRYAL não avaliza ou assegura a regularidade e a licitude de transações que ocorreram ou venham a ocorrer, já que a tomada de decisão fica inteiramente a cargo do cliente. A PRYAL não é responsável por informações incorretas, faltantes ou divergentes, já que as informações são válidas somente no ato da vistoria. Em razão de se preocupar com os clientes e buscar sempre a transparência, a PRYAL informa que as empresas terceiras, fornecedoras das informações constantes em bancos de dados públicos e privados, não detém acesso e meios para a obtenção de registros advindos do RENAJUD.</p></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")
  const _component_Form = _resolveComponent("Form")
  const _directive_mask = _resolveDirective("mask")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Form, {
            class: "form w-100",
            id: "kt_login_signin_form",
            onSubmit: _ctx.onSubmitLogin,
            "validation-schema": _ctx.login
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_Field, {
                  class: "form-control form-control-lg form-control-solid",
                  type: "text",
                  name: "renavam",
                  autocomplete: "off"
                }),
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_ErrorMessage, { name: "renavam" })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createVNode(_component_Field, {
                  class: "form-control form-control-lg form-control-solid",
                  type: "text",
                  name: "placa",
                  autocomplete: "off"
                }, null, 512), [
                  [_directive_mask, 'AAA-#X##']
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _createVNode(_component_ErrorMessage, { name: "placa" })
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("label", _hoisted_15, [
                  _createVNode(_component_Field, {
                    class: "form-check-input",
                    type: "checkbox",
                    name: "toc",
                    value: "1",
                    onChange: _ctx.setToc
                  }, null, 8, ["onChange"]),
                  _hoisted_16
                ])
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("button", {
                  type: "submit",
                  ref: "submitButton",
                  id: "kt_sign_in_submit",
                  class: "btn btn-lg btn-primary w-100 mb-5",
                  disabled: _ctx.toc === false
                }, [
                  _hoisted_18,
                  _hoisted_19
                ], 8, ["disabled"])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_20, [
      _hoisted_21
    ], 512)
  ], 64))
}